import ResourceManager from "./ResourceManager";

const TESTIMONIALS_RESOURCE = {
  key: "testimonials",
  label: "Testimonial",
  route: "testimonials",
  entity: "testimonials",
  titleField: "name",
  fields: [
    { name: "quote", label: "Quote", type: "textarea" },
    { name: "name", label: "Person Name", type: "text" },
    { name: "designation", label: "Designation / Role", type: "text" },
    { name: "organization", label: "Organization / Department", type: "text" },
    { name: "photo_url", label: "Photograph (upload)", type: "image" },
    { name: "rating", label: "Rating (1–5)", type: "number" },
    { name: "order", label: "Order", type: "number" },
    { name: "status", label: "Status (Draft / Published)", type: "status" },
    { name: "is_active", label: "Active", type: "boolean" },
  ],
};

export default function AdminTestimonials() {
  return <ResourceManager resource={TESTIMONIALS_RESOURCE} />;
}
